import { List, ListItem, Button } from "@mui/material";
import { forwardRef } from "react";

const CustomListBoxWithShowMore = forwardRef(function CustomListBox(
  { children, nextPageURL, onShowMore, ...rest },
  ref
) {
  return (
    <List ref={ref} {...rest} style={{ maxHeight: 200, overflow: "auto" }}>
      {children}
      {nextPageURL && (
        <ListItem>
          <Button fullWidth size="small" variant="outlined" onClick={onShowMore}>
            Show More
          </Button>
        </ListItem>
      )}
    </List>
  );
});

export default CustomListBoxWithShowMore;
